import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import axiosInstance from "utils/axiosInstance";

const Account = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    const handleDeleteAccount = async () => {
        try {
            await axiosInstance.delete('/api/user');

            localStorage.clear();
			sessionStorage.clear();
            delete axiosInstance.defaults.headers.common['Authorization'];

            setShowModal(false);
            navigate('/login');
        } catch (error) {
            console.error('Failed to delete account:', error);
        }
    };

    return (
        <>
            <p>Account settings</p>

            <div className="mt-4">
                <label className="form-label text-danger">
                    Delete your account permanently
                </label>
                <button
                    className="btn btn-danger d-block"
                    onClick={() => setShowModal(true)}
                >
                    Delete Account
                </button>
            </div>


            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete your account? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteAccount}>
                        Delete Account
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Account;
